<template>
  <div class="forget-password-modular">
    <div class="header-modular">
      <headerInfo></headerInfo>
    </div>
    <div class="logo-modular" style="margin-bottom: 245px;">
      <img class="logo-img" :src="logo" alt=""  @click="toIndex"/>
      <div class="forget-text">{{ pageTextArr[0] }}</div>
      <div class="address-text">{{ pageTextArr[6] }}</div>
      <div class="form-msg">
        <div class="login-input marginTop75">
          <span class="title">
            <span class="red-color">*</span>
            {{ pageTextArr[1] }}</span
          >
          <input type="text" class="account padding20" v-model="email" />
        </div>
        <div>
          <button class="login-button marginTop45" @click="toemaiVerification">
            {{ pageTextArr[3] }}
          </button>
        </div>
      </div>
    </div>
    <footerInfo></footerInfo>
  </div>
</template>

<script>
import headerInfo from "../components/public/headerInfo";
import footerInfo from "../components/public/footerInfo";

export default {
  components: {
    headerInfo,
    footerInfo,
  },
  data() {
    return {
      logo: "",
      email: "", //18839800564@163.com
      currLanguage: localStorage.getItem("curLanguageType"),
      pageTextArr: [
        "忘记密码",
        "邮箱地址",
        "请填写邮箱地址",
        "继续",
        "发送成功",
        "发送失败",
        "输入与您的 锦格 账户相关联的电子邮箱地址。"
      ],
    };
  },
  methods: {
    /**
     * 继续- 邮箱验证
     */
    toemaiVerification() {
      let that = this;
      if (that.email) {
        that.sendFindPasswordEmail();
      } else {
        this.$message({
          type: "warning",
          message:
            this.currLanguage == 3
              ? "Please fill in the email address!"
              : this.pageTextArr[2],
        });
      }
    },

    /**
     * 送忘记密码验证码邮件
     */
    sendFindPasswordEmail() {
      let that = this;
      let data = {
        email: this.email,
      };
      this.$http.sendFindPasswordEmail(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(this.pageTextArr[4]);
            this.$router.push({
              path: "/emaiVerification",
              query: {
                email: that.email,
              },
            });
          } else {
            this.$message.error(this.pageTextArr[5]);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr) {
      let that = this;
      let newpagetextArr = [];
      that.translateByArr(arr, (res) => {
        console.log("res", res);
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation);
        });
        that.pageTextArr = newpagetextArr;
      });
    },
    /**
     * 获取网站logo以及名称
     */
    getSystemConfig() {
      this.$http.getSystemConfig({}, (res) => {
        if (res.ret == 1) {
          this.logo = res.data.sys_site_logo;
        }
      });
    },
    /**
     * 点击图标可跳转到首页
     */
     toIndex() {
      this.$router.push({
        path: "/",
      });
    },
  },
  mounted() {
    let that = this;
    that.languageTranslateByArrs(that.pageTextArr);
    this.getSystemConfig();
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/view/forgetPassword.vue